import * as React from 'react';
import ContentLoader from 'react-content-loader';
const LogoLoader = (props) => {
    return (React.createElement(ContentLoader, { viewBox: "0 0 400 200", height: 200, width: 400, speed: 2, title: "Logo", ...props },
        React.createElement("rect", { x: "20", y: "8", rx: "0", ry: "0", width: "100", height: "100" }),
        React.createElement("rect", { x: "20", y: "120", rx: "0", ry: "0", width: "100", height: "10" }),
        React.createElement("rect", { x: "170", y: "8", rx: "0", ry: "0", width: "300", height: "15" }),
        React.createElement("rect", { x: "170", y: "30", rx: "0", ry: "0", width: "300", height: "15" }),
        React.createElement("rect", { x: "170", y: "52", rx: "0", ry: "0", width: "100", height: "15" })));
};
export default LogoLoader;
//# sourceMappingURL=logo-loader.js.map